<template>
    <button class="hamburger hamburger--spin"
            type="button"
            aria-label="Menu"
            aria-controls="navigation"
            :class="{ 'is-active': isOpen }"
            :aria-expanded="isOpen"
            @click="toggle">
        <span class="hamburger-box">
            <span class="hamburger-inner"/>
        </span>
    </button>
</template>

<script>
    // see also https://github.com/jonsuh/hamburgers
    import { mapActions, mapState } from 'vuex';

    export default {
        computed: {
            ...mapState('lateral-menu', ['isOpen']),
        },
        methods: {
            ...mapActions('lateral-menu', ['toggle']),
        },
    };
</script>
